'use client'

import { AboutSection } from '@/components/site/about-section'
import { ContactSection } from '@/components/site/contact-section'
import { HeroSection } from '@/components/site/hero-section'
import { InstagramSection } from '@/components/site/instagram-section'
import { ProcessSection } from '@/components/site/process-section'
import { ServicesSection } from '@/components/site/services-section'
import { SiteShell } from '@/components/site/site-shell'
import { TestimonialsSection } from '@/components/site/testimonials-section'
import { WorkSection } from '@/components/site/work-section'

export default function HomePage() {
  return (
    <SiteShell>
      <HeroSection />
      <WorkSection mode="featured" />
      <ServicesSection />
      <ProcessSection />
      <AboutSection />
      <TestimonialsSection />
      <InstagramSection />
      <ContactSection />
    </SiteShell>
  )
}
